/**
 * AlertaCargaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {AlertaCarga} from '@/model/resource/AlertaCarga'

/* TODO: review generated class */
@HttpExclude()
export class AlertaCargaCollection extends PageCollection<AlertaCarga> {
  constructor() {
    super(AlertaCarga)
  }

  queryAsPage() {
    return this.listAlertaCarga()
  }

  async listAlertaCarga() {
    return await Request.get(`/admin/alerta-carga`, {params: this.params})
      .name('listAlertaCarga')
      .as(this)
      .getResponse()
  }

  async listCsvAlertaCarga() {
    return await Request.get(`/admin/alerta-carga/csv`, {params: this.params})
      .name('listCsvAlertaCarga')
      .as(this)
      .getResponse()
  }
}
